<template>
  <div class="annotation-edit" :class="[{edit:annotation.isEdit()}, {active}]" @click.stop="select"
       @dblclick.stop="edit()">
    <div class="row">
      <div class="annotation-image col-5 pr-2" v-if="annotation.image.hasMedia() && !annotation.isEdit()">
        <img :src="annotation.image.media" alt="">
      </div>
      <div class="col-12">
        <div class="title-h2" v-if="!annotation.isEdit() && !annotation.isNew()">
          {{ $t('ID') + ': ' + annotation.getId() }}
        </div>
        <div class="text" v-if="!annotation.isEdit()">
          {{ annotation.text }}
        </div>
        <input-media :label="$t('Image')" v-model="annotation.image" :storieId="annotation.getStoryId()"
                     v-if="annotation.isEdit()" @change="addImage"/>
        <input-textarea :label="$t('Text')" :placeholder="$t('Annotation')" v-model="annotation.text"
                        v-if="annotation.isEdit()" ref="textarea"/>
      </div>
      <div class="btns">
        <btn square @click="save" v-if="annotation.isEdit()">
          <tooltip :text="$t('Save changes')" delay="0.5s" position="left">
            <i class="fal fa-save"></i>
          </tooltip>
        </btn>
        <btn square remove @click="remove" v-if="annotation.isEdit()">
          <tooltip :text="$t('Remove annotation')" delay="0.5s" position="left">
            <i class="fal fa-trash"></i>
          </tooltip>
        </btn>
        <btn square @click="cancel" v-if="annotation.isEdit()">
          <tooltip :text="$t('Cancel changes')" delay="0.5s" position="left">
            <i class="fal fa-times"></i>
          </tooltip>
        </btn>
        <btn square @click="annotation.edit()" v-if="!annotation.isEdit() && !annotation.isNew()">
          <tooltip :text="$t('Edit annotation')" delay="0.5s" position="left">
            <i class="fal fa-edit"></i>
          </tooltip>
        </btn>
        <btn square @click="newAnnotation" v-if="!annotation.isEdit() && annotation.isNew()">
          <tooltip :text="$t('Add annotation')" delay="0.5s" position="left">
            <i class="fal fa-plus"></i>
          </tooltip>
        </btn>
      </div>
    </div>
  
  </div>
</template>

<script>
import InputTextarea from '@/modules/input/input-textarea'
import {annotation} from '@/class/annotation/annotation'
import Btn from '@/modules/buttons/btn'
import Tooltip from '@/modules/tooltip'
import Card from '@/modules/items/card'
import InputMedia from '@/modules/input/input-media'

export default {
  name: 'annotation-edit',
  components: {InputMedia, Card, Tooltip, Btn, InputTextarea},
  props: {
    annotation: {type: Object, default: () => new annotation()},
    active: Boolean
  },
  data () {
    return {}
  },
  computed: {
    hasChange () {
      return this.annotation._data.text.valueOf() !== this.annotation.text
    }
  },
  methods: {
    select () {
      if (this.annotation.isEdit() || this.annotation.isNew()) return
      this.$emit('select', this.annotation)
    },
    addImage (value) {
      console.log(value)
      this.annotation.image.setMedia({id : value.id, url:value.media, size:value.size })
      console.log(this.annotation.image)
    },
    async save () {
      if (this.annotation.isNew()) {
        this.annotation.unEdit()
        await this.annotation.save()
        this.$emit('select', this.annotation)
        this.$emit('refresh')
        return
      }
      this.annotation.patch(['text', 'image'])
      this.annotation.unEdit()
    },
    cancel () {
      this.annotation.text = this.annotation._data.text.valueOf()
      this.annotation.unEdit()
    },
    remove () {
      return this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('Confirm'),
        text: this.$t('Do you really want to remove this annotation ? The link will be remove'),
        acceptText: this.$t('Yes, remove it'),
        cancelText: this.$t('No'),
        accept: this.removeConfirm
      })
    },
    async removeConfirm () {
      await this.annotation.delete()
      this.$emit('refresh')
    },
    edit () {
      if (this.annotation.isNew()) {
        return this.newAnnotation()
      }
      this.annotation.edit()
    },
    newAnnotation () {
      this.annotation.edit()
      this.annotation.text = ''
    }
  },
  watch: {
    'annotation._edit' (value) {
      if (!value) return
      this.$nextTick().then(() => {
        this.$refs.textarea.focusInput()
      })
    }
  }
}
</script>
